import React from 'react';

interface DashboardTabsProps {
  activeTab: 'MAIN' | 'SECTIONS';
  onChange: (tab: 'MAIN' | 'SECTIONS') => void;
}

const TABS: { id: 'MAIN' | 'SECTIONS'; label: string; short: string }[] = [
  { id: 'MAIN', label: 'Main Dashboard', short: 'Overview' },
  { id: 'SECTIONS', label: '5-Section Dashboard', short: 'Sections' },
];

export function DashboardTabs({ activeTab, onChange }: DashboardTabsProps) {
  return (
    <div className="segmented" role="tablist" aria-label="Dashboard view">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => onChange(tab.id)}
          className="segmented-item"
        >
          <span className="sm:hidden">{tab.short}</span>
          <span className="hidden sm:inline">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}
